import cleanDeep from 'clean-deep';

/**
 * Provider used to preprocess translations files that goes to $translate
 * service.
 */
export class TranslationsProvider {
  private $translateProvider: ng.translate.ITranslateProvider;

  constructor($translateProvider: ng.translate.ITranslateProvider) {
    'ngInject';

    this.$translateProvider = $translateProvider;
  }

  /**
   * @param {string} langKey
   * language key
   * @param {Object} translationTable
   * object with all translations
   * @returns {Void} nothing
   * Drop in replacement for {@link
   * https://angular-translate.github.io/docs/#/api/pascalprecht.translate.$translateProvider#methods_translations
   * $translateProvider.translations}. It's cleaning up the empty
   * translations, to make sure they default correctly to one provided by
   * fallback language.
   */
  translations(
    langKey: string,
    translationTable: ng.translate.ITranslationTable,
  ): void {
    this.$translateProvider.translations(langKey, cleanDeep(translationTable));
  }

  /**
   * Empty service, only provider is used here.
   * @returns {Void} nothing
   */
  $get() {}
}
